"use strict";
exports.__esModule = true;
var portfolioUncertainty_chart_maker_1 = require("../logic/portfolioUncertainty-chart-maker");
angular.module('smartorg.r6.acts.portfolioUncertainty').directive('portfolioUncertainty', ["$timeout", function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/portfolioUncertainty.html'),
            scope: {
                menu: '='
            },
            link: function (scope) {
                scope.showCDF = true;
                scope.$on('command:PORTFOLIO_UNCERTAINTY', function (event, args) {
                    showMetalog(args);
                });
                function showMetalog(args) {
                    scope.numDecimals = 2;
                    scope.Math = window.Math;
                    scope.actionMenuItem = args.actionMenuItem;
                    scope.dataForEachKey = args.config.data.data.DataForEachKey;
                    var currentKeyIndex = 0;
                    if (scope.chosenKeyDataOnReload &&
                        (scope.actionMenuItem == scope.actionMenuItemOnReload)) {
                        for (var i = 0; i < scope.dataForEachKey.length; i++) {
                            if (scope.chosenKeyDataOnReload.Title == scope.dataForEachKey[i].Title) {
                                currentKeyIndex = i;
                            }
                        }
                    }
                    scope.chosenKeyData = scope.dataForEachKey[currentKeyIndex];
                    // scope.portfolioUncExplanation = args.config.data.PortfolioUncExplanation;
                    scope.showFittedPointsHelp = false;
                    scope.nodeName = args.config.data.data.HighlightedNodeName;
                    var portfolioName = args.treeName;
                    if (localStorage.getItem('PortfolioConfig') &&
                        portfolioName in JSON.parse(localStorage.getItem('PortfolioConfig'))) {
                        var portfolioConfig = JSON.parse(localStorage.getItem('PortfolioConfig'))[portfolioName];
                        scope.showTable = portfolioConfig['chart']['showTable'] != "false";
                        scope.numDecimals = portfolioConfig['chart']['decimals'];
                        scope.showTooltip = portfolioConfig['chart']['showTooltip'] != "false";
                        scope.showChartExplanation = portfolioConfig['chart']['showChartExplanation'] != "false";
                    }
                    else if (args.config.data.settings) {
                        scope.showTable = args.config.data.settings.showTable != "false";
                        scope.showTooltip = args.config.data.settings.showTooltip != "false";
                        scope.numDecimals = args.config.data.settings.decimals;
                        scope.showChartExplanation = args.config.data.settings.showChartExplanation != "false";
                    }
                    if (scope.numDecimals == "Default") {
                        if (args.config.data.settings.defaultPrecision) {
                            scope.numDecimals = args.config.data.settings.defaultPrecision;
                        }
                        else {
                            scope.numDecimals = null;
                        }
                    }
                    if (scope.showTableOnReload &&
                        (scope.actionMenuItem == scope.actionMenuItemOnReload)) {
                        scope.showTable = scope.showTableOnReload;
                    }
                    // var currentRollup = mvsRollups[0]; //TODO: Change based on
                    // dropdown if more than one
                    //based on dropdown if more than one
                    setTimeout(function () {
                        scope.config = {
                            'showMetalog': false,
                            'showPoland': true,
                            'apply': scope.$apply(),
                            'showTooltip': scope.showTooltip,
                            'decimals': scope.numDecimals
                        };
                        updateMenu();
                        var portfolioUncertaintyChartMaker = new portfolioUncertainty_chart_maker_1["default"].PortfolioChartMakerFactory().makePortfolioUncertaintyChartMaker(scope.config, scope.chosenKeyData);
                        if (scope.showCDF) {
                            portfolioUncertaintyChartMaker.draw(new portfolioUncertainty_chart_maker_1["default"].CDFPointExtractor());
                        }
                        else {
                            portfolioUncertaintyChartMaker.draw(new portfolioUncertainty_chart_maker_1["default"].PDFPointExtractor());
                        }
                    }, 0);
                    // scope.mvsFromMetalogCalculated = portfolioUncertaintyChartMaker.portfolioUncData.main.metalogOutputs.mvsCalculated;
                    // scope.mvsFromPolandCalculated = portfolioUncertaintyChartMaker.portfolioUncData.main.polandOutputs.mvsCalculated;
                }
                scope.changeChart = function () {
                    var portfolioUncertaintyChartMaker = new portfolioUncertainty_chart_maker_1["default"].PortfolioChartMakerFactory().makePortfolioUncertaintyChartMaker(scope.config, scope.chosenKeyData);
                    if (scope.showCDF) {
                        portfolioUncertaintyChartMaker.draw(new portfolioUncertainty_chart_maker_1["default"].CDFPointExtractor());
                    }
                    else {
                        portfolioUncertaintyChartMaker.draw(new portfolioUncertainty_chart_maker_1["default"].PDFPointExtractor());
                    }
                };
                scope.selectNewKey = function () {
                    scope.actionMenuItemOnReload = angular.copy(scope.actionMenuItem);
                    scope.chosenKeyDataOnReload = angular.copy(scope.chosenKeyData);
                    scope.changeChart();
                };
                scope.exportCharts = function () {
                    var exporter = new smartorg.r6.lib.ChartExporter("metalogChart", "svg-canvas");
                    var title = scope.actionMenuItem + " for " +
                        scope.nodeName;
                    exporter.exportChart(title, true);
                };
                scope.chosenNodeTocvs = function (csv, chosenData) {
                    chosenData.map(function (curveData) {
                        csv += curveData.name + "\n";
                        csv += "Low (10 Percentile), Mid (50 Percentile)," +
                            " High (90 Percentile)\n";
                        csv += "" + curveData.polandOutputs.tenFiftyNinety.ten + ", " +
                            curveData.polandOutputs.tenFiftyNinety.fifty + ", " +
                            curveData.polandOutputs.tenFiftyNinety.ninety + "\n";
                        csv += "Summary Data for " + curveData.name + "\n";
                        csv += " Portfolio Elements, Mean, Variance, Skewness\n";
                        curveData.mvsLeafData.map(function (item) {
                            csv += item['name'] + ", " + item['Mean'] + ", " +
                                item['Variance'] + ", " + item['Skewness'] + "\n";
                        });
                        csv += "Total, " + curveData.rollUp.TotalMean + ", " +
                            curveData.rollUp.TotalVariance + ", " +
                            curveData.rollUp.TotalSkewness + "\n";
                    });
                    return csv;
                };
                scope.getDatecvs = function () {
                    var dateInString = new Date().toString();
                    var splitTimestamp = dateInString.split(" ");
                    var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
                    var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
                    return "" + splitTimestamp[1] + " " + splitTimestamp[2] + " " +
                        splitTimestamp[3] + " " + timeWithoutSec + " " + timeZone + " ";
                };
                scope.exportCsv = function (EU) {
                    if (EU === void 0) { EU = false; }
                    var csv = "";
                    if (scope.chosenKeyData.shadow) {
                        csv = scope.chosenNodeTocvs(csv, scope.chosenKeyData.main) +
                            "\n" + scope.chosenNodeTocvs(csv, scope.chosenKeyData.shadow);
                    }
                    else {
                        csv = this.chosenNodeTocvs(csv, scope.chosenKeyData.main);
                    }
                    if (EU) {
                        csv = csv.replace(/,/g, ';');
                        csv = csv.replace(/\./g, ',');
                    }
                    var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
                    var currentDate = this.getDatecvs();
                    var filename = scope.actionMenuItem + "_" + scope.nodeName + "_" + currentDate + ".csv";
                    saveAs(blob, filename);
                };
                function updateMenu() {
                    scope.menu = [{
                            'name': 'Display',
                            'items': [{
                                    'name': scope.showTable ? 'Hide Table' : 'Show Table',
                                    'toggle': scope.showTable ? 'Show Table' : 'Hide Table',
                                    'callback': function () {
                                        scope.showTable = !scope.showTable;
                                        scope.showTableOnReload = angular.copy(scope.showTable);
                                        scope.actionMenuItemOnReload = angular.copy(scope.actionMenuItem);
                                    }
                                }, {
                                    'name': 'Show Probability Density Function',
                                    'toggle': 'Show Cumulative Distribution Function',
                                    'callback': function () {
                                        scope.showCDF = !scope.showCDF;
                                        scope.changeChart();
                                    }
                                }]
                        },
                        {
                            'name': 'Export',
                            'items': [{
                                    'name': 'Chart',
                                    'callback': function () {
                                        scope.exportCharts();
                                    }
                                }, {
                                    'name': 'Table',
                                    'callback': function () {
                                        scope.exportCsv();
                                    }
                                }, {
                                    'name': 'Table EU',
                                    'callback': function () {
                                        scope.exportCsv(true);
                                    }
                                }]
                        }
                    ];
                }
            }
        };
    }]);
//# sourceMappingURL=portfolioUncertainty-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/portfolio-uncertainty/app/js/plumbing/portfolioUncertainty-directive.js